/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useState, useEffect } from 'react';
import { message } from 'antd';
import CompanySelector from './components/CompanySelector';
import CompanyInformation from './components/CompanyInformation';
import CompanyTabs from './components/CompanyTabs';
import { Main } from '../../../styled';
import { PageHeader } from '../../../../components/page-headers/page-headers';
import { DataService } from '../../../../config/dataService/dataService';

function DataTable() {
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const [employeesData, setEmployeesData] = useState([]);
  const [cardsData, setCardsData] = useState([]);
  const [trainingsData, setTrainingsData] = useState([]);
  const [dateRange, setDateRange] = useState(null);
  const [fetchTriggered, setFetchTriggered] = useState(false);

  // Loading states
  const [companyLoading, setCompanyLoading] = useState(false);
  const [employeesLoading, setEmployeesLoading] = useState(false);
  const [cardsLoading, setCardsLoading] = useState(false);
  const [trainingsLoading, setTrainingsLoading] = useState(false);

  // Error states
  const [companyError, setCompanyError] = useState(null);
  const [employeesError, setEmployeesError] = useState(null);
  const [cardsError, setCardsError] = useState(null);
  const [trainingsError, setTrainingsError] = useState(null);

  const handleCompanySelect = (companyId) => {
    setSelectedCompany(companyId);
    if (companyId) {
      setFetchTriggered(false);
      setCompanyData(null);
      setEmployeesData([]);
      setCardsData([]);
      setTrainingsData([]);
      setCompanyError(null);
      setEmployeesError(null);
      setCardsError(null);
      setTrainingsError(null);
    }
  };

  const handleFetchData = async () => {
    if (!selectedCompany) return;

    setFetchTriggered(true);
    await Promise.all([
      fetchCompanyData(),
      fetchEmployeesData(),
      fetchCardsData(),
      fetchTrainingsData()
    ]);
  };

  const fetchCompanyData = async () => {
    try {
      setCompanyLoading(true);
      setCompanyError(null);

      const params = { companyId: selectedCompany };
      if (dateRange) {
        params.startDate = dateRange[0].format('YYYY-MM-DD');
        params.endDate = dateRange[1].format('YYYY-MM-DD');
      }

      const response = await DataService.post('/reports/company-info', params);
      if (response.data.status) {
        setCompanyData(response.data.data);
      } else {
        setCompanyError('Failed to fetch company information');
      }
    } catch (error) {
      console.error('Error fetching company data:', error);
      setCompanyError('Error fetching company information');
    } finally {
      setCompanyLoading(false);
    }
  };

  const fetchEmployeesData = async () => {
    try {
      setEmployeesLoading(true);
      setEmployeesError(null);

      const params = { companyId: selectedCompany };
      if (dateRange) {
        params.startDate = dateRange[0].format('YYYY-MM-DD');
        params.endDate = dateRange[1].format('YYYY-MM-DD');
      }

      const response = await DataService.post('/reports/company-employees-date-wise', params);
      if (response.data.status) {
        setEmployeesData(response.data.data || []);
      } else {
        setEmployeesError('Failed to fetch employees data');
      }
    } catch (error) {
      console.error('Error fetching employees data:', error);
      setEmployeesError('Error fetching employees data');
    } finally {
      setEmployeesLoading(false);
    }
  };

  const fetchCardsData = async () => {
    try {
      setCardsLoading(true);
      setCardsError(null);

      const params = { companyId: selectedCompany };
      if (dateRange) {
        params.startDate = dateRange[0].format('YYYY-MM-DD');
        params.endDate = dateRange[1].format('YYYY-MM-DD');
      }

      const response = await DataService.post('/reports/company-cards-date-wise', params);
      if (response.data.status) {
        setCardsData(response.data.data || []);
      } else {
        setCardsError('Failed to fetch cards data');
      }
    } catch (error) {
      console.error('Error fetching cards data:', error);
      setCardsError('Error fetching cards data');
    } finally {
      setCardsLoading(false);
    }
  };

  const fetchTrainingsData = async () => {
    try {
      setTrainingsLoading(true);
      setTrainingsError(null);

      const params = { companyId: selectedCompany };
      if (dateRange) {
        params.startDate = dateRange[0].format('YYYY-MM-DD');
        params.endDate = dateRange[1].format('YYYY-MM-DD');
      }

      const response = await DataService.post('/reports/company-trainings-date-wise', params);
      if (response.data.status) {
        setTrainingsData(response.data.data || []);
      } else {
        setTrainingsError('Failed to fetch trainings data');
      }
    } catch (error) {
      console.error('Error fetching trainings data:', error);
      setTrainingsError('Error fetching trainings data');
    } finally {
      setTrainingsLoading(false);
    }
  };

  const handleDateRangeChange = (dates) => {
    setDateRange(dates);
  };

  return (
    <>
      <PageHeader className="ninjadash-page-header-main" title="" routes={[]} />

      <Main>
        <div className="p-4">
          {/* Company Selector - Centered with large font */}
          <div className="flex justify-center mb-8">
            <div className="w-full max-w-2xl">
              <CompanySelector
                onCompanySelect={handleCompanySelect}
                selectedCompany={selectedCompany}
                onFetchData={handleFetchData}
                dateRange={dateRange}
                onDateRangeChange={handleDateRangeChange}
                dataFetched={fetchTriggered}
              />
            </div>
          </div>

          {/* Show components only after fetch data is triggered */}
          {fetchTriggered && selectedCompany && (
            <>
              {/* Company Information */}
              <CompanyInformation
                companyData={companyData}
                loading={companyLoading}
                error={companyError}
              />

              {/* Tabs */}
              <CompanyTabs
                employeesData={employeesData}
                cardsData={cardsData}
                trainingsData={trainingsData}
                employeesLoading={employeesLoading}
                cardsLoading={cardsLoading}
                trainingsLoading={trainingsLoading}
                employeesError={employeesError}
                cardsError={cardsError}
                trainingsError={trainingsError}
                startDate={dateRange?.[0]?.format('DD-MM-YYYY')}
                endDate={dateRange?.[1]?.format('DD-MM-YYYY')}
              />
            </>
          )}
        </div>
      </Main>
    </>
  );
}

export default React.memo(DataTable);
